import type { FaireProductEntity } from "../../entity_types/product";

export const p_5882ghhnqp: FaireProductEntity = {
  token: "p_5882ghhnqp",
  type: "product",
  name: "Smoked Cherry– HI-FI Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0e85880448fc9240f3df3853d2e5008d3021b39e7cdfdce23baac54523cae8ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9fb1d220080ada1ff065fe4e82db1bae6124547ad9d06d58c3c8c842a42a32cb.jpeg",
    "https://cdn.faire.com/fastly/35be466f5d0df869894a305848d54b1e42427ea04aeeb76752a061b1e1fc752d.jpeg",
    "https://cdn.faire.com/fastly/05f6d481993fac8a13cef3b19a602629a977da25cb59fef87e8b09a7eefe7059.jpeg",
    "https://cdn.faire.com/fastly/9f4e49232650237d8c84c3d6c13953feb88db063ef3b595a661d5bcb8f8182fc.jpeg",
    "https://cdn.faire.com/fastly/0bbdc137fd1da852c6fa7b1984f0686ab4e636a6176daab6d362a28d6264b7d6.jpeg",
  ],
  priceDollars: 9.5,
  description:
    '*RESTOCKING IN SUMMER 2026*\n\n\nAn organic take on a gourmand, like biting into a whiskey-tinged maraschino cherry. Fruity and a little earthy. Marasca cherry, ylang-ylang, and smoked cedar.\n\nPRODUCT INFORMATION:\n\nIncense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach vermilion-hued charcoal-based Incense stick is hand-dipped in California using fine fragrance oils.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours.\n\n20 sticks within a plastic sleeve and packaged into a premium drawer style box.  Each stick is approximately 7" long.',
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:01.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
